export const isLoadedInsideIframe = !(window === window.parent);